import { Component, Inject, inject, Input, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '@shared/services/shared.service';
import { IAuditLog } from 'app/models/audit-log/audit-log';
import { AuditLogService } from 'app/services/audit-log/audit-log.service';

export interface IAuditLogDialogData {
  entityKey: number;
  entityType: string;
}

@Component({
  selector: 'audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent implements OnInit {
  public auditLogs: IAuditLog[] = [];

  public sharedService = inject(SharedService);
  public auditService = inject(AuditLogService);
  public dialog = inject(MatDialog);

  constructor(@Inject(MAT_DIALOG_DATA) public data: IAuditLogDialogData,
              private dialogRef: MatDialogRef<AuditLogComponent>) { }

  public ngOnInit(): void {
    this.getAuditLogs();
  }

  getAuditLogs(): void {
    this.auditService.getAuditLogs(this.data.entityKey, this.data.entityType).subscribe({
      next: response => this.auditLogs = response,
      error: error => {
        console.error(error);
        this.sharedService.toastr.error('Error getting audit logs')
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
